import { useEffect, useState } from "react"
import { Data, Modal, ModalId, useUIState } from "../../../../ui"
import { PhoneForm } from "./phoneForm"

type Props = {
    data?: Data
    onSubmit: (phone: number) => void
}

export const PhoneFormModal = (props: Props) => {
    const { data, onSubmit } = props
    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()

    useEffect(() => setKey(key + 1), [openedModal])
    
    return (
        <Modal
            modalId={ModalId.PHONE_FORM}
            title="Agregar Teléfono"
            actions={[]}
        >
            <PhoneForm
                key={key}
                data={data}
                onSubmit={onSubmit}
            />
        </Modal>
    )
}
